import { Component, computed, ViewChild, ElementRef, Output, EventEmitter, NgZone, effect, Input, signal, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { GenericValidationService } from '@app/common-codes/services/GenericValidationService';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { Account as TenantAccount } from '@app/common-codes/models/matwins-tenant/Account.model';
import { TreeNode } from '@app/common-codes/components/nested-components/tree-node/tree-node.component';
import { TreeViewComponent } from '@app/common-codes/components/nested-components/tree-view/tree-view.component';
import { PermissionsService } from '@app/common-codes/services/Permissions.service';
import { AccountBase } from '@app/common-codes/models/AccountBase.model';


@Register(AccountBase)
@Component({
  selector: 'app-permissions-detail',
  templateUrl: './permissions-detail.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, TranslatePipe, TreeViewComponent]
})
export class AccountPermissionsDetailComponent extends GenetricDetailComponent<AccountBase> {

  override ComponentEntityClass = AccountBase;
  @Input() fkPointOfServiceId: number | null = null;
  Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  @Output() itemSaved = new EventEmitter<AccountBase>();

  permissionsData!: TreeNode;

  // entityNames: string[] = ['Client', 'PointOfService', 'Dock', 'Trucker', 'TruckerActivity'];
  // featureNames: string[] = ['EmployeeList.ExportPDF_Button', 'AccountDetail.ShowPermissions_Button', 'TruckerActivity.ImageContainer_Component'];


  constructor(
    route: ActivatedRoute,
    router: Router,
    translationService: TranslationService,
    validationService: GenericValidationService,
    alertModalService: AlertModalService,
    ngZone: NgZone
  ) {
    super(route, router, translationService, validationService, ngZone);
    this.alertModalService = alertModalService;
    this.viewModelProperties = ['permissions'];

    effect(() => {
      const entity = this.editingEntity();
      if (entity) {
        if (entity.permissions) {
          if (entity.permissions === '{}' && entity.role) {
            const defaultPermissions = JSON.parse(entity.role.defaultPermissions);
            entity.permissions = JSON.stringify(this.permissionsService.InferAccountPermissionsFromDefault(defaultPermissions)); // JSON.stringify(permissionsData);
          }

          this.permissionsData = JSON.parse(entity.permissions);
        }
      }
    });
  }

  override getEmptyEntity(): AccountBase {
    const account = new AccountBase();
    // account.defaultPermissions = JSON.stringify(this.permissionsService?.GenerateDefaultPermissionsForAccount(this.entityNames, this.featureNames)); // JSON.stringify(permissionsData);

    return account;
  }

  override parseToEntityInstance(): void {
    if (this.EntityInstance && this.editingEntity()) {
      Object.assign(this.EntityInstance, this.editingEntity());
    }
  }

  onChange(data: TreeNode) {
    this.editingEntity()!.permissions = JSON.stringify(data);
  }

  isTenantAccount(a: AccountBase | null | undefined): a is TenantAccount {
    return !!a && 'accountPOS' in a;
  }

  async saveItem(): Promise<void> {
    const entity = this.editingEntity();

    if (this.isTenantAccount(entity)) {
      const tenantEntity = entity as TenantAccount;
      tenantEntity.accountPOS?.forEach(element => {
        element.pointOfService = undefined;
        element.account = undefined;
      });
    }
    const savedItem = await this.save();
    if (savedItem) {
      this.itemSaved.emit(savedItem);
    }
  }

  async saveAndCloseItem(): Promise<void> {
    const entity = this.editingEntity();

    if (this.isTenantAccount(entity)) {
      const tenantEntity = entity as TenantAccount;

      tenantEntity.accountPOS?.forEach(element => {
        element.pointOfService = undefined;
        element.account = undefined;
      });
    }
    const savedItem = await this.save();
    if (savedItem) {
      this.itemSaved.emit(savedItem);
      this.closeModal.emit();
    }
  }

}
